String.prototype.dj_toArray = function(separator = '') {
    return this.split(separator);
}
